var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-bar" },
    [
      _c("router-link", { attrs: { to: { name: "Index" } } }, [
        _c("h2", { staticClass: "bold" }, [
          _vm._v("\n            Instacash\n        "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "routes" },
        [
          _c("router-link", { attrs: { to: { name: "Index" } } }, [
            _vm._v("\n            Home\n        "),
          ]),
          _vm._v(" "),
          _c(
            "a-dropdown",
            [
              _c(
                "a",
                [
                  _vm._v("\n                ファンド一覧\n                "),
                  _c("arrow-down"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-menu",
                { attrs: { slot: "overlay" }, slot: "overlay" },
                [
                  _c(
                    "a-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ProductList" } } },
                        [
                          _vm._v(
                            "\n                        ファンド一覧\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ProductHold" } } },
                        [
                          _vm._v(
                            "\n                        保有ファンド\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "TradeRecord" } } },
                        [
                          _vm._v(
                            "\n                        取引履歴\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("router-link", { attrs: { to: { name: "AboutUs" } } }, [
            _vm._v("\n            会社概要\n        "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user" },
        [
          _vm.finance.userEmail
            ? _c(
                "router-link",
                {
                  staticClass: "b3 user-email",
                  attrs: { to: { name: "Profile" } },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.finance.userName || _vm.finance.userEmail) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("button", { staticClass: "b3 bold", on: { click: _vm.onClick } }, [
            _vm._v("\n            " + _vm._s(_vm.btnText) + "\n        "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }